// src/services/explore.js
import http from "../lib/http";

/**
 * List products with full filtering, search, pagination, and sort support.
 *
 * Accepted params (all optional):
 *   page          – page number (default 1)
 *   limit         – items per page (default 24)
 *   query         – search by product name
 *   category_name – filter by category name (e.g. "Womens wear")
 *   min_price     – minimum price
 *   max_price     – maximum price
 *   sort          – "price_asc" | "price_desc" | "most_sold" | "new" | "featured"
 *
 * API response shape:
 *   {
 *     message        : string,
 *     total_products : number,   ← total across all pages
 *     returned_count : number,   ← items on this page
 *     pagination     : { current_page, per_page, total, last_page, next_page_url, prev_page_url },
 *     seed           : number,
 *     data           : Product[]
 *   }
 */
export const listProducts = (params = {}) => {
  const clean = {};

  if (params.page)          clean.page          = params.page;
  if (params.limit)         clean.limit         = params.limit;
  if (params.query?.trim()) clean.query         = params.query.trim();
  if (params.category_name?.trim()) clean.category_name = params.category_name.trim();
  if (params.min_price > 0) clean.min_price     = params.min_price;
  if (params.max_price > 0) clean.max_price     = params.max_price;
  if (params.sort)          clean.sort          = params.sort;

  return http.get("/api/customer/products", { params: clean });
};